<template>
  <div>

    <!-- NAVBAR -->
    <nav class="app-navbar">
      <div class="app-navbar-left">

        <router-link to="/app/dashboard" class="logo">
          <img src="@/assets/nca_logo.png" alt="NoCodeAgent.ai" />
          <span>NoCodeAgent.ai</span>
        </router-link>

      </div>

      <div class="app-navbar-right">

        <router-link to="/create-agent" class="btn-primary">
          {{ $t('actions.create') }}
        </router-link>
        
        <div class="user-menu" @click="toggleDropdown">
          <span>{{ user?.name || $t('common.account') }}</span>

          <div v-if="isOpen" class="dropdown" @click.stop>
            <div class="dropdown-header">
              <strong>{{ user?.name || 'User'}}</strong>
              <small>{{ user?.email }}</small>
            </div>
            
            <div class="dropdown-divider"></div>
            
            <router-link to="/agents" class="dropdown-item">
              {{ $t('menu.agent') }}
            </router-link>

            <div class="dropdown-divider"></div>

            <router-link to="/app/settings" class="dropdown-item">
              {{ $t('menu.settings') }}
            </router-link>

            <router-link to="/app/plan" class="dropdown-item">
              {{ $t('menu.plan') }}
            </router-link>

            <div class="dropdown-divider"></div>

            <button class="dropdown-item logout" @click="logout">
              {{ $t('logout') }}
            </button>
          </div>
        </div>

      </div>
    </nav>

    <!-- CONTENT -->
    <main>
      <router-view />
    </main>

    <!-- FOOTER (AMÉLIORÉ MAIS MÊME STRUCTURE) -->
    <footer class="footer footer-app">
      <div class="footer-inline">
        <span>© {{ new Date().getFullYear() }} NoCodeAgent.ai</span>

        <div class="footer-links">
          <a href="#">{{ $t('footer.privacy') }}</a>
          <span>·</span>
          <a href="#">{{ $t('footer.terms') }}</a>
          <span>·</span>
          <a href="#contact">{{ $t('footer.contact') }}</a>
        </div>
      </div>
    </footer>

  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import Cookies from 'js-cookie'
import router from '@/router'

const isOpen = ref(false)
const user = ref(null)

function toggleDropdown() {
  isOpen.value = !isOpen.value
}

function closeDropdown() {
  isOpen.value = false
}

function handleClickOutside(event) {
  if (!event.target.closest('.user-menu')) {
    closeDropdown()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)

  user.value = {
    name: localStorage.getItem('userName'),
    email: localStorage.getItem('userEmail')
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

function logout() {
  localStorage.clear()
  Cookies.remove('token')
  router.replace('/sign-in')
}
</script>
  
<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #eaeaea;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.navbar-logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333333;
  text-decoration: none;
}

.navbar-toggle {
  display: none;
  font-size: 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
}

.navbar-links {
  display: flex;
  gap: 1rem;
}

.navbar-link {
  text-decoration: none;
  color: #333333;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.navbar-link:hover,
.navbar-link.router-link-active {
  background-color: #f0f0f0;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .navbar-toggle {
    display: block;
  }

  .navbar-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #ffffff;
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
    display: none;
  }

  .navbar-links.open {
    display: flex;
  }

  .navbar-link {
    width: 100%;
    padding: 0.75rem 1rem;
  }
}

.footer-app {
  background: #020617;
  color: #6b7280;
  padding: 12px 20px;
  font-size: 0.75rem;
  border-top: 1px solid #1e293b;
}

.footer-inline {
  max-width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* liens */
.footer-links {
  display: flex;
  gap: 8px;
  align-items: center;
}

.footer-links a {
  color: #9ca3af;
  text-decoration: none;
}

.footer-links a:hover {
  color: #e5e7eb;
}

@media (max-width: 768px) {
  .footer-inline {
    flex-direction: column;
    gap: 5px;
    text-align: center;
  }
}

.app-navbar {
  height: 64px;
  background: #020617;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #1e293b;
}

/* LEFT */
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: white;
  font-weight: 800;
  letter-spacing: 0;
}

.logo img {
  width: 32px;
  height: 32px;
  display: block;
  border-radius: 8px;
  background: #ffffff;
  padding: 3px;
  object-fit: contain;
  box-sizing: border-box;
}

.logo span {
  white-space: nowrap;
}

/* RIGHT */
.app-navbar-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* BUTTON */
.btn-primary {
  background: #6366f1;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
}

/* USER */
.user-menu {
  background: #0f172a;
  padding: 8px 12px;
  border-radius: 8px;
}
.user-menu {
  position: relative;
  background: #0f172a;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
}

/* DROPDOWN */
.dropdown {
  position: absolute;
  right: 0;
  top: 110%;
  background: white;
  color: #111;
  border-radius: 10px;
  width: 220px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.2);
  overflow: hidden;
  z-index: 100;
}

/* HEADER */
.dropdown-header {
  padding: 12px;
  font-size: 0.85rem;
  background: #f9fafb;
}

.dropdown-header small {
  display: block;
  color: #666;
  margin-top: 3px;
}

/* ITEMS */
.dropdown-item {
  display: block;
  padding: 12px;
  text-decoration: none;
  color: #333;
  font-size: 0.9rem;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
}

.dropdown-item:hover {
  background: #f3f4f6;
}

/* DIVIDER */
.dropdown-divider {
  height: 1px;
  background: #eee;
}

/* LOGOUT */
.logout {
  color: #dc2626;
}

@media (max-width: 640px) {
  .app-navbar {
    height: 56px;
    padding: 0 14px;
  }

  .logo {
    gap: 7px;
    font-size: 0.95rem;
  }

  .logo img {
    width: 28px;
    height: 28px;
  }

  .app-navbar-right {
    gap: 8px;
  }

  .btn-primary {
    display: none;
  }

  .user-menu {
    padding: 7px 10px;
    font-size: 0.85rem;
  }
}
</style>
